import { IDmsConfig } from './../../interface/document.manager.interface';
import { Component, Input, OnInit,OnChanges, SimpleChanges,OnDestroy } from "@angular/core";
import { DocumentManagerService } from "../../services/document-manager.service";
import { Subscription } from 'rxjs';
@Component({
    selector: "app-document-tree-node",
    templateUrl: "./document-tree-node.component.html",
    styleUrls: ["./document-tree-node.component.scss"],
})
export class DocumentTreeNodeComponent implements OnInit,OnChanges,OnDestroy {
    @Input("list") list = [];
    @Input("parentList") parentList = [];
    @Input() folderChange:boolean;
    @Input() dmsConfig:IDmsConfig;
    subscription: Subscription[] = [];
    localParentList: Array<any> = [];
    selectedFolder: string = "";
    constructor(private DocumentManagerService: DocumentManagerService) {}

    ngOnInit() {
        this.subscription.push(this.DocumentManagerService.redirectFolder.subscribe((response) => {
            this.setSelectedFolder(response[response.length - 1].ItemId);
        }));

        this.syncWithBreadCrumb();

        this.subscription.push(this.DocumentManagerService.breadCrumbChange.subscribe(() => {
            this.folderOpenSync();
        }));

        this.subscription.push(this.DocumentManagerService.refreshFolder.subscribe(() => {
            const index = this.list
                .map((e) => e.item.ItemId)
                .indexOf(this.selectedFolder);
            if (index >= 0) {
                this.manageRoute(index);
            }
        }));
    }

    folderOpenSync() {
        const breadcrumb = this.checkBreadCrumb();
        if (breadcrumb === null) return;

        this.list.forEach((item, i) => {
            if (
                breadcrumb.length - 1 > item.level &&
                item.item.ItemId === breadcrumb[breadcrumb.length - 1].ItemId
            ) {
                item.isOpen = true;
                this.manageRoute(i);
            }
        });

        this.setSelectedFolder(breadcrumb[breadcrumb.length - 1].ItemId);
    }

    syncWithBreadCrumb() {
        const breadcrumb = this.checkBreadCrumb();
        if (breadcrumb === null) return;

        this.list.forEach((item, i) => {
            if (
                breadcrumb.length - 1 > item.level &&
                item.item.ItemId === breadcrumb[item.level + 1].ItemId
            ) {
                item.isOpen = true;
                // let event:MouseEvent;
                // this.nodeToggle(event,i);
                this.manageRoute(i);
            }
        });
        this.setSelectedFolder(breadcrumb[breadcrumb.length - 1].ItemId);
    }

    setSelectedFolder(itemId) {
        this.selectedFolder = itemId;
    }
    ngOnChanges(changes:SimpleChanges){
        if(changes.folderChange && !changes.folderChange.firstChange){
        this.DocumentManagerService.breadCrumbChange.subscribe(() => {
            this.folderOpenSync();
        });
        }
        this.syncWithBreadCrumb();

    }

    checkBreadCrumb() {
        const breadcrumb = JSON.parse(localStorage.getItem(this.dmsConfig&&this.dmsConfig.BreadcrumbName));
        if (breadcrumb === null) return null;
        if (breadcrumb.length < 2) return null;
        return breadcrumb;
    }

    nodeToggle(e, index) {
        e.stopPropagation();
        e.preventDefault();
        this.toggler(index);
    }

    toggler(index: any) {
        this.list.forEach((item) => {
            if (item.item.ItemId === this.list[index].item.ItemId) {
                item.isOpen = !this.list[index].isOpen;
            } else {
                item.isOpen = false;
            }
        });
        this.manageRoute(index);
    }

    manageRoute(index) {
        this.localParentList = [];
        if (this.list[index].isOpen) {
            this.list[index].isReady = false;
            this.localParentList.push(this.list[index].item);
            this.DocumentManagerService.getChildFolders.emit(this.list[index]);
        } else {
            const delIndex = this.localParentList
                .map(function (e) {
                    return e.ItemId;
                })
                .indexOf(this.list[index].item.ItemId);
            this.localParentList.splice(delIndex, 1);
        }

        this.localParentList = [...this.parentList, ...this.localParentList];
    }

    redirectHere(e, item, i) {
        e.preventDefault();

        if (!this.list[i].isOpen) {
            this.nodeToggle(e, i);
        }
        this.DocumentManagerService.redirectFolder.emit([
            ...this.parentList,
            item.item,
        ]);
    }
    ngOnDestroy() {
        if (this.subscription && this.subscription.length) {
            this.subscription.forEach((sub) => {
                sub.unsubscribe();
            });
        }
    }
}
